
import { TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Checkbox } from "@/components/ui/checkbox";
import { useEffect, useRef } from "react";

interface AppTableHeaderProps {
  showSelect?: boolean;
  isAllSelected?: boolean;
  isSomeSelected?: boolean;
  onSelectAll?: (checked: boolean) => void;
}

export const AppTableHeader = ({ 
  showSelect = false, 
  isAllSelected = false, 
  isSomeSelected = false, 
  onSelectAll 
}: AppTableHeaderProps) => {
  const checkboxRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (checkboxRef.current) {
      const checkboxElement = checkboxRef.current.querySelector('input[type="checkbox"]') as HTMLInputElement;
      if (checkboxElement) {
        checkboxElement.indeterminate = isSomeSelected && !isAllSelected;
      }
    }
  }, [isSomeSelected, isAllSelected]);

  return (
    <TableHeader>
      <TableRow>
        {showSelect && (
          <TableHead className="w-12 px-4">
            <Checkbox
              ref={checkboxRef}
              checked={isAllSelected}
              onCheckedChange={onSelectAll}
            />
          </TableHead>
        )}
        <TableHead className="w-20 px-4">Icon</TableHead>
        <TableHead className="w-80 px-4 pl-8">App Name</TableHead>
        <TableHead className="w-48 px-4 hidden sm:table-cell">Category</TableHead>
        <TableHead className="w-32 px-4 hidden lg:table-cell">Type</TableHead>
      </TableRow>
    </TableHeader>
  );
};
